import { Component, OnInit, Input } from '@angular/core';
/* import { NbDialogRef } from '@nebular/theme'; */
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Component({
  selector: 'ngx-edit-logbook',
  templateUrl: './edit-logbook.component.html',
  styleUrls: ['./edit-logbook.component.scss'],
})
export class EditLogbookComponent implements OnInit {
  @Input() stationId: string;
  @Input() logbook: any;
  @Input() logbookType: number;
  constructor(
    /* protected ref: NbDialogRef<EditLogbookComponent>, */
  ) { }

  ngOnInit() {
  }

  close() {
    /* this.ref.close(); */
  }

  logbookCreated() {
    this.alert('Bitácora editada con éxito');
    /* this.ref.close(true); */
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
